/**
 * IMPORTANT: This file serves as a wrapper for whisper-core and is served via livePaths.
 * Since livePaths doesn't support long-term frontend caching, we need to keep imports
 * from whisper-core to a minimum. This architecture allows whisper-core.js to leverage
 * frontend caching while this wrapper file handles dynamic loading through livePaths.
 */

import( /* webpackChunkName: "whisper-core-entry" */'./whisper-core').catch(() => {
  // Ignore the error handling since it's handled by the whisper-core.ts file.
});